import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/guest';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearGuestCheckout,
  fetchCheckout,
  setGuestCheckout,
} from 'actions/checkout';
import TextBox from 'theme/TextBox';
import Spinner from 'theme/Spinner';

import './style.less';

const Guest = ({ history }) => {
  const dispatch = useDispatch();
  const checkoutPending = useSelector((state) => state.checkout.pending);
  const redirectURL = useSelector((state) => state.checkout.context.redirect);
  const {
    pending: guestPending,
    success,
    error: errorMessage,
  } = useSelector((state) => state.checkout.guest);
  const { is_guest: guest, user_email: preOrderEmail } = useSelector(
    (state) => state.checkout.preOrder
  );

  const [email, setEmail] = useState(preOrderEmail || '');

  useEffect(() => {
    dispatch(fetchCheckout());

    return () => dispatch(clearGuestCheckout());
  }, []);

  useEffect(() => {
    if (preOrderEmail) {
      setEmail(preOrderEmail);
    }
  }, [preOrderEmail]);

  useEffect(() => {
    const shouldRedirect =
      !checkoutPending && (!guest || redirectURL || (success && !errorMessage));

    if (shouldRedirect) {
      history.push($R.CHECKOUT.path);
    }
  }, [checkoutPending, guest, redirectURL, success, errorMessage]);

  const onInputChange = (value) => {
    setEmail(value);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    dispatch(setGuestCheckout(email));
  };

  if (checkoutPending) {
    return <Spinner />;
  }

  return (
    <div className='guest-checkout headerMargin'>
      <form className='guest-checkout__form' onSubmit={onSubmit}>
        <p className='guest-checkout__form--title'>
          {$ST.ORDER_WITHOUT_ACCOUNT}
        </p>
        <TextBox
          type='text'
          name='email'
          placeholder={$ST.EMAIL}
          value={email}
          onChange={onInputChange}
        />
        <p className='guest-checkout__form--error'>{errorMessage}</p>
        <button
          type='submit'
          className='button pointer'
          disabled={guestPending}
        >
          {$ST.SUBMIT}
        </button>
      </form>
    </div>
  );
};

export default Guest;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/customer/guest/index.js